export default __webpack_public_path__ + "static/media/homeHeaderBG.53b2003c.png";